import { useState } from "react";
import { getProblemMessage } from "../utils/http";

/**
 * The Manage-dialog action scaffold: `run(action)` flips the busy flag around the promise,
 * clears/sets the trailing error Alert's message, and reports success via `onSuccess`
 * (typically the dialog's `onFinish`). Pass a custom `busy` setter when an action carries its
 * own flag (e.g. a comment composer busy separately from Save Details); `setLoading` /
 * `setErrorMessage` are exposed for actions that manage the promise themselves.
 */
export function useDialogAction(options?: { onSuccess?: () => void }) {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  function run(
    action: () => Promise<unknown>,
    busy: (value: boolean) => void = setLoading,
  ): void {
    busy(true);
    setErrorMessage("");
    action()
      .then(() => {
        busy(false);
        options?.onSuccess?.();
      })
      .catch((err) => {
        busy(false);
        setErrorMessage(getProblemMessage(err));
      });
  }

  return { loading, setLoading, errorMessage, setErrorMessage, run };
}
